const now = new Date().toISOString();

export const demoSession = {
  user: {
    id: 'user_demo',
    email: 'client@example.com',
    name: 'JJE Client',
    avatarInitials: 'JC'
  },
  isAdmin: true,
  defaultClientId: 'client_demo',
  memberships: [
    {
      id: 'member_demo_admin',
      clientId: 'client_demo',
      clientName: 'Demo Small Business',
      clientSlug: 'demo-small-business',
      clientStatus: 'active',
      role: 'jje_admin',
      status: 'active'
    }
  ]
};

export const demoOverview = {
  ok: true,
  client: {
    id: 'client_demo',
    name: 'Demo Small Business',
    slug: 'demo-small-business',
    status: 'active',
    billingEmail: 'owner@example.com',
    preferredOwnershipModel: 'hybrid',
    passwordManagerRef: '1Password: Demo Small Business vault',
    offboardingNotes: 'Client owns domain; JJE manages Cloudflare Pages and GitHub deployment until handoff.',
    stripeCustomerId: 'cus_demo'
  },
  serviceLevel: {
    enrollmentId: 'svc_demo',
    clientId: 'client_demo',
    packageKey: 'momentum_care',
    name: 'Momentum Care',
    shortName: 'Momentum',
    summary: 'Priority website care with monthly improvement capacity, analytics review, and proactive planning.',
    status: 'active',
    responseTarget: '1 business day',
    monthlyRequestAllowance: 6,
    monthlyStrategySessions: 1,
    includesPriorityQueue: true,
    includesAnalytics: true,
    includesAutomation: false,
    entitlements: {
      portal: true,
      work: true,
      requests: true,
      assets: true,
      billing: true,
      priorityQueue: true,
      analytics: true,
      automation: false,
      strategy: true,
      requestLimitLabel: '6 priority requests / month',
      supportLabel: 'Priority care queue',
      planningCadence: 'Monthly planning check-in'
    },
    stripeSubscriptionId: 'sub_demo_momentum',
    startedAt: now,
    endsAt: null,
    internalNotes: 'Demo workspace uses Momentum Care.'
  },
  servicePackages: [
    {
      key: 'foundation_care',
      name: 'Foundation Care',
      shortName: 'Foundation',
      summary: 'Core portal access, request tracking, file exchange, billing, and standard website support.',
      responseTarget: '2 business days',
      monthlyRequestAllowance: 2,
      monthlyStrategySessions: 0,
      includesPriorityQueue: false,
      includesAnalytics: false,
      includesAutomation: false,
      entitlements: {
        requestLimitLabel: '2 standard requests / month',
        supportLabel: 'Standard request queue',
        planningCadence: 'As-needed planning'
      }
    },
    {
      key: 'momentum_care',
      name: 'Momentum Care',
      shortName: 'Momentum',
      summary: 'Priority website care with monthly improvement capacity, analytics review, and proactive planning.',
      responseTarget: '1 business day',
      monthlyRequestAllowance: 6,
      monthlyStrategySessions: 1,
      includesPriorityQueue: true,
      includesAnalytics: true,
      includesAutomation: false,
      entitlements: {
        requestLimitLabel: '6 priority requests / month',
        supportLabel: 'Priority care queue',
        planningCadence: 'Monthly planning check-in'
      }
    },
    {
      key: 'signature_growth',
      name: 'Signature Growth',
      shortName: 'Signature',
      summary: 'Highest-touch growth support with proactive roadmap, conversion experiments, and automation workflows.',
      responseTarget: 'Same or next business day',
      monthlyRequestAllowance: 12,
      monthlyStrategySessions: 2,
      includesPriorityQueue: true,
      includesAnalytics: true,
      includesAutomation: true,
      entitlements: {
        requestLimitLabel: '12 priority/growth requests / month',
        supportLabel: 'Signature response queue',
        planningCadence: 'Biweekly strategy and optimization'
      }
    }
  ],
  clients: [
    { id: 'client_demo', name: 'Demo Small Business', status: 'active', preferredOwnershipModel: 'hybrid' },
    { id: 'client_wallflowers', name: 'Williamson Wallflowers', status: 'active', preferredOwnershipModel: 'client_owned' }
  ],
  projects: [
    {
      id: 'proj_site',
      clientId: 'client_demo',
      name: 'Website Care Plan',
      status: 'active',
      summary: 'Monthly updates, uptime checks, backups, and content improvements.',
      phase: 'Ongoing care',
      progress: 68,
      nextMilestone: 'May update batch',
      dueDate: '2026-05-29',
      productionUrl: 'https://example.com'
    },
    {
      id: 'proj_refresh',
      clientId: 'client_demo',
      name: 'Service Page Refresh',
      status: 'planning',
      summary: 'New service copy, proof points, and quote request cleanup.',
      phase: 'Discovery',
      progress: 24,
      nextMilestone: 'Approve outline',
      dueDate: '2026-06-07'
    }
  ],
  sites: [
    {
      id: 'site_main',
      clientId: 'client_demo',
      projectId: 'proj_site',
      name: 'Main Website',
      domain: 'example.com',
      ownershipModel: 'hybrid',
      hostingProvider: 'Cloudflare Pages',
      cloudflareAccountRef: 'Client-owned account; JJE invited as admin',
      githubRepoRef: 'github.com/client/site',
      passwordManagerRef: '1Password item reference only'
    }
  ],
  requests: [
    {
      id: 'req_hours',
      clientId: 'client_demo',
      projectId: 'proj_site',
      projectName: 'Website Care Plan',
      title: 'Update holiday hours on contact page',
      pageArea: 'Contact page',
      requestType: 'content',
      details: 'Add Memorial Day closure and June summer hours.',
      priority: 'normal',
      status: 'in_progress',
      createdAt: now,
      updatedAt: now
    },
    {
      id: 'req_gallery',
      clientId: 'client_demo',
      projectId: 'proj_refresh',
      projectName: 'Service Page Refresh',
      title: 'Swap homepage gallery images',
      pageArea: 'Homepage',
      requestType: 'design',
      details: 'Use the three new install photos from the May folder.',
      priority: 'high',
      status: 'queued',
      createdAt: now,
      updatedAt: now
    }
  ],
  files: [
    {
      id: 'file_logo',
      clientId: 'client_demo',
      originalFilename: 'updated-brand-photos.zip',
      mimeType: 'application/zip',
      size: 4200000,
      note: 'May update assets',
      createdAt: now
    }
  ],
  billing: [
    {
      id: 'bill_maintenance',
      clientId: 'client_demo',
      kind: 'subscription',
      description: 'Website Care Plan',
      amountCents: 19900,
      currency: 'usd',
      status: 'active',
      hostedInvoiceUrl: '',
      createdAt: now
    },
    {
      id: 'bill_invoice',
      clientId: 'client_demo',
      kind: 'invoice',
      description: 'Service Page Refresh deposit',
      amountCents: 85000,
      currency: 'usd',
      status: 'open',
      hostedInvoiceUrl: 'https://stripe.com/'
    }
  ],
  comments: [
    {
      id: 'comment_client_1',
      requestId: 'req_hours',
      authorUserId: 'user_demo',
      authorName: 'JJE Client',
      body: 'Can you also note that we reopen on June 3?',
      createdAt: new Date(Date.now() - 60 * 60 * 1000).toISOString()
    },
    {
      id: 'comment_1',
      requestId: 'req_hours',
      authorName: 'JJE Creative',
      body: 'I have the hours update queued for the next publish batch.',
      createdAt: now
    }
  ],
  auditEvents: [
    {
      id: 'audit_1',
      actorName: 'JJE Admin',
      eventType: 'request_created',
      entityType: 'change_request',
      createdAt: now
    }
  ]
};
